import React from 'react';
import { Link } from 'react-router-dom';
import {
  Link as MuiLink,
  TableRow,
  TableCell,
  Typography,
} from '@mui/material';

const ExpiredCardTableRow = ({
  id,
  account,
  name,
  email,
  phone,
  nameOnCard,
  cardType,
  cardNumber,
  expiryDate,
}) => (
  <TableRow key={id}>
    <TableCell>
      <MuiLink component={Link} tabIndex={0} to={'/admin/customers/' + id}>
        {account}
      </MuiLink>
    </TableCell>
    <TableCell>{name}</TableCell>
    <TableCell>{email}</TableCell>
    <TableCell>{phone}</TableCell>
    <TableCell>{nameOnCard}</TableCell>
    <TableCell>{cardType}</TableCell>
    <TableCell>{cardNumber}</TableCell>
    <TableCell>{expiryDate}</TableCell>
  </TableRow>
);

export default ExpiredCardTableRow;
